export enum TipoNotaFiscalObraEnum {

  Prestada = "Nota Fiscal Prestada",
  Deduzida = "Nota Fiscal Deduzida"
}
